import { useDispatch, useSelector } from 'react-redux'
import { IconButton, Snackbar } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

import { setError } from '../container/home'

const SnackBar = () => {
  const error = useSelector(state => state.home.error)
  const dispatch = useDispatch()

  const errorHandler = () => dispatch(setError())

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={!!error}
      onClose={errorHandler}
      message={error}
      action={
        <IconButton size='small' onClick={errorHandler}>
          <CloseIcon fontSize='small' />
        </IconButton>
      }
    />
  )
}

export default SnackBar
